import { ApiError, BaseResponseType, apiClient } from 'shared/api';

import { ReferralCodeCheckResult } from '../model/dto';

/** 클릭 집계 (공개 API, 비로그인 호출 가능). 유효하지 않은 코드는 서버가 조용히 무시한다 */
export const postReferralClick = async ({ code, channel }: { code: string; channel: string | null }): Promise<void> => {
  await apiClient.post('/referral/click', { code, channel });
};

export const validateReferralCode = async (code: string): Promise<BaseResponseType<ReferralCodeCheckResult>> => {
  const { data } = await apiClient.get('/referral/validation', { code });

  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data;
};
